module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik03IDBDMy4xMyAwIDAgMy4xMyAwIDdDMCAxMi4yNSA3IDIwIDcgMjBDNyAyMCAxNCAxMi4yNSAxNCA3QzE0IDMuMTMgMTAuODcgMCA3IDBaTTcgOS41QzUuNjIgOS41IDQuNSA4LjM4IDQuNSA3QzQuNSA1LjYyIDUuNjIgNC41IDcgNC41QzguMzggNC41IDkuNSA1LjYyIDkuNSA3QzkuNSA4LjM4IDguMzggOS41IDcgOS41WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/navbar/shipment.svg
// module id = N6gr
// module chunks = 1